import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
import { PreAuditValue } from '../../interface';

interface PreAuditMoreButtonProps {
  hiddenValues: PreAuditValue[];
}

const PreAuditMoreButton: React.FC<PreAuditMoreButtonProps> = ({ hiddenValues }) => {
  if (!hiddenValues.length) return null;

  const tooltipContent = (
    <Typography variant="p4" color="var(--tooltip-text-color)">
      {hiddenValues.map(value => value.label).join(', ')}
    </Typography>
  );

  return (
    <Tooltip placement="top" hideStrategy="referenceHidden">
      <TooltipTrigger>
        <Typography variant="p3" color="var(--blue-base)" className="flex-shrink-0 cursor-pointer">
          +{hiddenValues.length} more
        </Typography>
      </TooltipTrigger>
      <TooltipContent className={cx('tooltipWrapper', 'max-w-[300px]')}>
        {tooltipContent}
      </TooltipContent>
    </Tooltip>
  );
};

export default PreAuditMoreButton;
